<template>
  <div>
    <el-divider class="cml-divider" content-position="center">品牌权限配置</el-divider>
    <el-row type="flex" justify="space-around">
      <el-col :span="10">
        <el-form
          @submit.native.prevent
          class="cml-search-form"
          ref="listForm"
          :inline="true"
          size="mini"
        >
          <el-row>
            <el-form-item label="花名">
              <el-input
                v-model.trim="tableParam.data.loginName"
                @keyup.13.native="onSearch"
                clearable
              ></el-input>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" @click="onSearch">查询</el-button>
            </el-form-item>
          </el-row>
          <el-row>
            <el-col>
              <CommonTable
                ref="CommonTableRef"
                :showCheckbox="false"
                showRadioBox
                :loading="tableLoading"
                :tableHead="tableHead"
                :tableData="tableData"
                :tableParam="tableParam"
                :layouts="['JumpNumber', 'FullJump', 'Total']"
                @page-size-change="pageSizeChange"
                @radio-change="radioChange"
              ></CommonTable>
            </el-col>
          </el-row>
        </el-form>
      </el-col>

      <el-col :span="13">
        <el-row style="margin-top: -13px">
          <CommonTable
            ref="CommonTableRef2"
            class="CommonTable2"
            :showCheckbox="false"
            showRadioBox
            :showPage="false"
            :tableHead="tableHead2"
            :tableData="{list: tableData2}"
            @radio-change="selectChange2"
          ></CommonTable>
          <el-button
            size="small"
            style="margin: -20px 0 0 45%"
            type="primary"
            :disabled="!selectData2.label || !selectData.id"
            :loading="saveLoading"
            @click="saveBtn"
            >保 存</el-button
          >
        </el-row>
      </el-col>
    </el-row>
  </div>
</template>
<script>
import CommonTable from '@/components/CommonTable';
import { mapGetters } from 'vuex';

export default {
  name: 'banner-permission',
  components: {
    CommonTable,
  },
  data() {
    return {
      tableLoading: false,
      saveLoading: false,
      tableParam: {
        pageNo: 1,
        pageSize: 20,
        data: {
          loginName: '',
          customerId: '0',
        },
      },
      tableData: {},
      tableData2: [],
      tableHead: [
        { prop: 'loginName', label: '花名' },
        { prop: 'account', label: '登录名' },
      ],
      tableHead2: [
        { prop: 'label', label: '品牌' },
      ],
      selectData: {},
      selectData2: {},
    };
  },
  computed: {
    ...mapGetters(['allDictListData'])
  },
  mounted() {
    this.getUser();
    this.$refs.CommonTableRef.changeHeight(-60);
    this.$refs.CommonTableRef2.changeHeight(-60);
    this.tableData2 = this.allDictListData.data.cml_brand
  },
  methods: {
    onSearch() {
      this.tableParam.pageNo = 1;
      this.getUser();
      this.selectData2 = {};
    },
    // 用户
    getUser() {
      this.$http.setting
        .getUserList(this.tableParam)
        .then(result => {
          this.tableData = result.data;
          this.selectData = {};
          this.$refs.CommonTableRef2.clearRadioRow()
          this.$refs.CommonTableRef.clearRadioRow()
        })
        .catch(err => {
          this.$message.error(err.msg);
        });
    },
    // 保存
    saveBtn() {
      const params = {id: this.selectData.id, brand: this.selectData2.value }
      this.saveLoading = true;
      this.$http.setting
        .updateBrand(params)
        .then(result => {
          this.$message.success(result.msg);
        })
        .catch(err => {
          this.$message.error(err.msg);
        })
        .finally(() => {
          this.saveLoading = false;
        });
    },
    // 用户选择
    radioChange(obj) {
      this.selectData = obj; 
      // 获取用户品牌权限
      this.$nextTick(() => {
        this.$http.setting
          .getCUserBrand(obj.id)
          .then(result => {
            if (!result.data.brand) {
              this.selectData2 = {};
              this.$refs.CommonTableRef2.clearRadioRow()
              return
            }
            this.selectData2= this.tableData2.find(item => {
              return  item.value === JSON.stringify(result.data.brand)
            })
            this.$refs.CommonTableRef2.setRadioRow(this.selectData2)
          })
          .catch(err => {
            this.$message.error(err.msg);
          });
      });
    },
    selectChange2(selection) {
      this.selectData2 = selection;
    },
    pageSizeChange(pageNo, pageSize) {
      this.tableParam.pageNo = pageNo;
      this.tableParam.pageSize = pageSize;
      this.getUser();
    },
  },
};
</script>

<style lang="less" scoped>
.CommonTable2 {
  margin-top: 47px;
}
</style>
